import { CHANGE_VARIANT_ROUTE_INDEX } from 'root/src/client/logic/route/actionIds'

export default payload => ({
	type: CHANGE_VARIANT_ROUTE_INDEX,
	payload,
})
